<template>
  <div>
    <div class="grid max-w-xl grid-cols-3 px-6 py-3 mx-auto lg:p-6">
      <div>
        <slot name="back" />
      </div>
      <div></div>
      <div>
        <slot name="next" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookBottomBar',

  computed: {
    ...mapGetters('booking', ['steps', 'currentIndex'])
  }
}
</script>